import React from 'react';
import SkillTag from './SkillTag';

const ToolsSection = ({ toolsTags, onTagClick }) => {
  return (
    <div className="mb-8">
      <div className="flex flex-wrap gap-2">
        {toolsTags.map((tag, index) => (
          <SkillTag
            key={index}
            tag={tag}
            onClick={onTagClick}
          />
        ))}
      </div>
    </div>
  );
};

export default ToolsSection;